export class RandomUtils {
    static getRandomString(bytes: number) {
        const randomArray = new Uint8Array(bytes);
        crypto.getRandomValues(randomArray);
        return btoa(String.fromCharCode.apply(null, Array.from(randomArray)));
    }
}
